import React from 'react';
import './ValueCard3.less';

function ValueCard3({data: {title, img}}) {
  return (
    <div className='ValueCard3'>
      <div>
        <img src={img} alt='value' />
      </div>
      <h2>{title}</h2>
    </div>
  );
}

export default ValueCard3;


// WEBPACK FOOTER //
// ./src/routes/Case/ValueCard/ValueCard3.js